import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbDefinition } from 'xng-breadcrumb';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  
  @Input()
  customBreadcrumbsArray: BreadcrumbDefinition[] = [];

  constructor(
    public router: Router,
  ) { }

  ngOnInit(): void {
  }

}
